import classnames from 'classnames/bind';

import styles from './index.module.scss';
const cx = classnames.bind(styles);

const Loading = ({
  inline = false,
  className,
}: {
  inline?: boolean;
  className?: string;
}) => {
  const loadingClass = cx({
    loading: true,
    inline,
  });
  return (
    <div className={`${loadingClass} ${className ?? ''}`}>
      <div className={styles.dots} />
    </div>
  );
};

export default Loading;
